module.exports = __webpack_public_path__ + "img/icon3.eb88603a.png";